import chef from "../assets/chefMasse.png";
import "./styles.css";

function About() {
  return (
    <div className="about-page">
      <section className="about-hero">
        <h1>Our Philosophy</h1>
      </section>

      <section className="about-main">
        <div className="about-image">
          <img src={chef} alt="The owner" />
        </div>

        <div className="about-content">
          <p>
            At our core, we believe in honoring tradition without being bound by
            it. Chef Masse brings a deep respect for authentic Italian
            technique, drawing inspiration from the rich and diverse culinary
            regions of Italy while embracing the bold, creative spirit of
            Italian-American cuisine.
          </p>
          <p>
            As a chef-driven restaurant, we are committed to offering a dining
            experience that refuses to be limited by rigid culinary norms or the
            operation of a typical, formulaic restaurant. Instead, we focus on
            crafting dishes with integrity — balancing time-honored flavors with
            fresh, inventive ideas that evolve naturally from the kitchen's
            passion and expertise.
          </p>
          <p>
            Our atmosphere is casual yet elegantly inviting, designed to make
            every guest feel both comfortable and cared for. We believe the best
            culinary experiences are rooted in genuine hospitality, simplicity,
            and exceptional quality — without ever becoming overly fussy or
            extravagant.
          </p>
          <p>
            This is where <b>authenticity meets innovation</b>. Tradition is our
            foundation, creativity is our spirit, and delivering an approachable
            dining experience is our mission.
          </p>
        </div>
      </section>
    </div>
  );
}

export default About;
